import {
    GET_CLIENTS_REQUEST,
    GET_CLIENTS_SUCCESS,
    GET_CLIENTS_FAILURE,
    GET_TYPING_CLIENTS_REQUEST,
    SET_CLIENTS,
    SET_CLIENT,
    SUBMIT_CLIENT_SUCCESS,
    SUBMIT_CLIENT_REQUEST,
    SUBMIT_CLIENT_FAILURE,
    GET_CLIENT_REQUEST,
    GET_CLIENT_SUCCESS,
    GET_CLIENT_FAILURE
} from '../actions/clients';
import { buildClients, buildClient } from '../helpers/clients';
const initialState = {
    fetching: false,
    submitFetching: false,
    submitSuccess: false,
    clients: [],
    client: {},
    total: 0
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CLIENTS_REQUEST: {
            return {
                ...state,
                fetching: true,
                submitSuccess: false
            };
        }
        case GET_TYPING_CLIENTS_REQUEST: {
            return {
                ...state,
                fetching: true,
                clients: [],
                total: 0
            };
        }
        case GET_CLIENTS_SUCCESS: {
            return {
                ...state,
                fetching: false,
                clients: state.clients.concat(buildClients(action.payload.clients, action.payload.profiles)),
                total: (!action.payload.total || action.payload.total === 0) ? state.total : action.payload.total
            };
        }
        case GET_CLIENTS_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case SET_CLIENTS: {
            return {
                ...state,
                clients: action.payload.clients,
                total: action.payload.total
            };
        }
        case SET_CLIENT: {
            return {
                ...state,
                client: action.payload.client
            };
        }

        case SUBMIT_CLIENT_REQUEST: {
            return {
                ...state,
                submitFetching: true,
                submitSuccess: false
            };
        }
        case SUBMIT_CLIENT_SUCCESS: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: true,
                client: action.payload.client
            };
        }
        case SUBMIT_CLIENT_FAILURE: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: false
            };
        }
        case GET_CLIENT_REQUEST: {
            return {
                ...state,
                fetching: true,
                submitFetching: false,
                submitSuccess: false
            };
        }
        case GET_CLIENT_SUCCESS: {
            return {
                ...state,
                fetching: false,
                client: buildClient(action.payload.client, action.payload.profiles)
            };
        }
        case GET_CLIENT_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }

        default:
            return state;
    }
};
